export const DISPLAY_ALERT = 'SHOW_ALERT'
export const CLEAR_ALERT = 'CLEAR_ALERT'

export const LOGIN_USER_BEGIN = 'LOGIN_USER_BEGIN'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const LOGOUT_USER = 'LOGOUT_USER'

export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'

export const HANDLE_CHANGE = 'HANDLE_CHANGE'
export const CLEAR_VALUES = 'CLEAR_VALUES'

export const CREATE_INFORMATION_ITEM_BEGIN = 'CREATE_INFORMATION_ITEM_BEGIN'
export const CREATE_INFORMATION_ITEM_SUCCESS = 'CREATE_INFORMATION_ITEM_SUCCESS'
export const CREATE_INFORMATION_ITEM_ERROR = 'CREATE_INFORMATION_ITEM_ERROR'

export const GET_INFORMATION_ITEMS_BEGIN = 'GET_INFORMATION_ITEMS_BEGIN'
export const GET_INFORMATION_ITEMS_SUCCESS = 'GET_INFORMATION_ITEMS_SUCCESS'
export const GET_INFORMATION_ITEMS_ERROR = 'GET_INFORMATION_ITEMS_ERROR'

export const SET_EDIT_INFORMATION_ITEM = 'SET_EDIT_INFORMATION_ITEM'

export const DELETE_INFORMATION_ITEM_BEGIN = 'DELETE_INFORMATION_ITEM_BEGIN'

export const EDIT_INFORMATION_ITEM_BEGIN = 'EDIT_INFORMATION_ITEM_BEGIN'
export const EDIT_INFORMATION_ITEM_SUCCESS = 'EDIT_INFORMATION_ITEM_SUCCESS'
export const EDIT_INFORMATION_ITEM_ERROR = 'EDIT_INFORMATION_ITEM_ERROR'

export const CLEAR_FILTERS = 'CLEAR_FILTERS'

export const CHANGE_PAGE = 'CHANGE_PAGE'

export const CHANGE_MONTH_TO_DISPLAY = 'CHANGE_MONTH_TO_DISPLAY'

export const CHANGE_ROW = 'CHANGE_ROW'

export const CHANGE_SHOW_LOGOUT = 'CHANGE_SHOW_LOGOUT'